import React from "react"
import { useDispatch, useSelector } from "react-redux"
import HelpIcon from "@material-ui/icons/Help"
import MuiMenu from "@material-ui/core/Menu"
import MenuItem from "@material-ui/core/MenuItem"
import classNames from "classnames"
import ArrowDropDown from "@material-ui/icons/ArrowDropDown"
import IconMenu from "@material-ui/icons/Menu"
import IconButton from "@material-ui/core/IconButton"


import { Mobile, Desktop } from  "../components/device"
import { logout } from "../actions/auth"
import ErrorBoundary from "../utils/error_boundary"
import texts from "../utils/texts"
import UserConfirmDialog from "../molecules/user_confirm_dialog"
import Hr from "../atoms/hr"
import { makeStyles } from "@material-ui/core"
import { useState } from "react"
import { useHistory } from "react-router"
import { getMenuItems } from "../utils/menu"

const useClasses = makeStyles({
  root: { width: "100%" },
  indicator: { width: "5px" },
  arrowDropDown: { fill: "#bbb" },
  menuItem: {
    display: "flex",
    flexDirection: "column",
    minHeight: "min-content",
    alignItems: "flex-start",
  },
  linkMenuItem: {
    marginLeft: "5px",
    "&:link,&:visited": {
      color: "inherit",
      textDecoration: "inherit", 
    },
  },
  menuUser: {
    display: "flex",
    flexDirection: "column",
    minHeight: "min-content",
    alignItems: "flex-start",
    padding: "11px 33px 11px 11px",
    "&:focus" : { outline: "none" } 
  },
  userNameText: {
    fontSize: "18px",
    color: "#777",
    fontWeight: "700",
  },
  userPhoneText: {
    fontSize: "16px",
    color: "#ccc",
    fontWeight: "300",
  },
})

const Menu = () => {
  const classes = useClasses()
  const [isDialogOpen, setIsDialogOpen] = useState(false)
  const [isMenuOpen, setIsMenuOpen] = useState(false)
  const [anchorEl, setAnchorEl] = useState(null)
  const history = useHistory()

  const dispatch = useDispatch()
  const user = useSelector(s => s.auth?.user)
  const hasAuth = Boolean(user)
  const groups = user?.groups || {}

  const closeLogoutDialog = () => {
    setIsDialogOpen(false)
  }

  const closeMenu = () => {
    setIsMenuOpen(false)
    setAnchorEl(null)
  }

  const handleMenu = (event) => {
    setIsMenuOpen(true)
    setAnchorEl(event.currentTarget)
  }


  const onLogoutConfirmed = () => {
    closeLogoutDialog()
    dispatch(logout())
    gtag("event", "user_logout")
  }

  
  const handleMenuItem = (event) => {
    const value = event.currentTarget.getAttribute("value")
    if (value === "logout") {
      closeMenu()
      setIsDialogOpen(true)
      return
    }
    history.push(`/${value}`)
    closeMenu()
  }

  const userName = `${user?.firstName} ${user?.lastName}`

  return (
    <ErrorBoundary>
      <IconButton
        aria-owns={isMenuOpen ? "menu-appbar" : undefined}
        aria-haspopup="true"
        onClick={handleMenu}
        color="inherit"
      >
        <Desktop>
          <ArrowDropDown className={classes.arrowDropDown} />
        </Desktop>
        <Mobile>
          <IconMenu />
        </Mobile>
      </IconButton>
      <MuiMenu
        id="menu-appbar"
        anchorEl={anchorEl}
        open={isMenuOpen}
        onClose={closeMenu}
        anchorPosition={{ top: 200, left: 800 }}
        getContentAnchorEl={null}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "left",
        }}
        transformOrigin={{ vertical: "top", horizontal: "left" }}
      >
        {hasAuth && (
          <div className={classes.menuUser}>
            <span className={classes.userNameText}>{userName}</span>
            <span className={classes.userPhoneText}>{user.phone}</span>
            <span className={classes.userPhoneText}>{user.participantId}</span>
          </div>
        )}
        {hasAuth &&  <Hr />}
        {!hasAuth && <MenuItem className={classes.menuItem} value="signup" onClick={handleMenuItem}>{texts.signup}</MenuItem> }
        {!hasAuth && <MenuItem className={classes.menuItem} value="login" onClick={handleMenuItem}>{texts.login}</MenuItem> }
        {user && getMenuItems(user).map(item => (
          <MenuItem key={item.link} className={classes.menuItem} value={item.link} onClick={handleMenuItem}>{item.text}</MenuItem>
        ))}
        {hasAuth && <MenuItem 
          className={classes.menuItem} 
          value="edit-details" 
          onClick={handleMenuItem}
        >
          {texts.updateDetails}
        </MenuItem>}
        {hasAuth && <MenuItem className={classes.menuItem} value="logout" onClick={handleMenuItem}>{texts.logout}</MenuItem>}
      </MuiMenu>
      <UserConfirmDialog
        isDialogOpen={isDialogOpen}
        title={texts.logout}
        body={texts.areYouSureYouWantToLeave}
        textOk={texts.textButtonYesIWantToLogOut}
        textCancel={texts.imStaying}
        onConfirm={onLogoutConfirmed}
        onClose={closeLogoutDialog}
      />
    </ErrorBoundary>
  )
}

export default Menu
